module.exports = __webpack_public_path__ + "img/bulb.51df7957.svg";